import { Connection } from 'src/store/connections/types';
import {
  DEFAULT_STARDOG_FEATURES,
  IsSupported,
  StardogFeature,
} from 'src/store/features/types';
import { ReduxState } from 'src/store/types';

export const isStardogFeatureSupportedSelector =
  (key: IsSupported<StardogFeature>, connection: Connection | null) =>
  (state: ReduxState) =>
    ((connection && state.features.stardogByConnectionId[connection.id]) ||
      DEFAULT_STARDOG_FEATURES)[key];
